import { render, staticRenderFns } from "./ListCriteria.vue?vue&type=template&id=182437e0"
import script from "./ListCriteria.vue?vue&type=script&lang=js"
export * from "./ListCriteria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports